import * as React from 'react';
import styles from './calendar-day.module.css';

export class CalendarDayPlaceholder extends React.Component {
    render() {
        return <div className={styles['container-empty']} />;
    }
}
